
const AcreageOverviewCard = () => {
    
    return (
        
        <div className="AcreageOverviewCard card table-responsive">
            <div className="px-0 py-0 card-body">
                <table className="table table-sm card-table table-borderless">
                    <tbody>
                        <tr>
                            <td className="text-muted" colSpan={2}>
                                Acreage Overview
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Open</td>
                            <td>N/A</td>
                            <td>N/A</td>
                        </tr>
                        <tr>
                            <td>Leased</td>
                            <td>N/A</td>
                            <td>N/A</td>
                        </tr>
                        <tr>
                            <td>Unconfirmed</td>
                            <td>N/A</td>
                            <td>N/A</td>
                        </tr>
                        <tr>
                            <td>TOTAL</td>
                            <td>N/A</td>
                            <td>N/A</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
    )
    
}

export default AcreageOverviewCard
